<template>
  <p>VIZBI 2019 was held at the
    <a href="https://www.embl.de/training/cco/atc/">EMBL Advanced Training Centre</a> (ATC), located
    on the EMBL Heidelberg campus:
  </p>
  <p style="margin-left: 2em;">
    <a href="https://maps.google.com/maps?q=Meyerhofstra%C3%9Fe+1,+69117+Heidelberg,+Germany">
      Meyerhofstra&szlig;e 1, 69117 Heidelberg, Germany
    </a>
  </p>
  <img src="/2019/Venue/venue.png" alt="EMBL Advanced Training Centre" />
  <p>The EMBL conference office provides
    <a href="https://www.embl.de/training/events/info_participants/index.html">general information
      for participants</a>, a
    <a href="https://www.embl.de/training/events/info_participants/faqs/index.html">FAQ page</a>,
    and information on
    <a href="https://www.embl.de/aboutus/contact/travel/index.html">how to get to EMBL</a>.
  </p>
  <h4>Accommodation</h4>
  <p>Accommodation was <strong>not included</strong> in the conference registration fee. The
    following partner hotels offered rooms at a discounted rate with booking code
    <strong>VZB19-01</strong>:
  </p>
  <div id="hotels">
    <a v-for="hotel in hotels" :key="hotel[0]" :href="hotel[1]">{{ hotel[0] }}</a>
  </div>
  <h4>What type of room can I book?</h4>
  <ul>
    <li>Single room &mdash; a room with a single bed for 1 person only</li>
    <li>Superior single room &mdash; a larger single room or a double room used as a single</li>
    <li>Double room &mdash; a room with double bed ideally for a couple</li>
    <li>Twin room &mdash; a room with 2 single beds for 2 persons</li>
    <li>Shared twin room &mdash; the use of a single bed in a twin room (shared with another participant)</li>
  </ul>
  <p><em>Note: not all room types are available in every hotel.</em></p>
  <h4>Conference Shuttle Buses</h4>
  <p>A free shuttle bus service was provided for VIZBI 2019 participants, running between designated
    hotel stops and EMBL each morning and evening. Bus stops were:
  </p>
  <ul>
    <li>Gottlieb-Daimler-Stra&szlig;e (Star Inn Hotel)</li>
    <li>Kurfürsten-Anlage (opposite main train station)</li>
    <li>Neckarmünzplatz</li>
    <li>Peterskirche</li>
    <li>Crowne Plaza (back entrance)</li>
    <li>ISG Hotel, Boxberg</li>
  </ul>
  <p class="centered">
    <a href="/2019/Venue/BusSchedule.pdf" download>Download Conference Bus Schedule (PDF)</a>
  </p>
  <a
    class="bus-schedule-link" href="/2019/Venue/BusSchedule.pdf" download
    title="Download Conference Bus Schedule (PDF)">
    <img src="/2019/Venue/BusSchedule.png" alt="Conference bus schedule" />
  </a>
  <h4>Public Transport</h4>
  <p>
    Bus 39 (destination EMBL) runs from Bismarckplatz &mdash; the main bus and tramway stop in
    Heidelberg city centre &mdash; to EMBL. The fare was €2.40, paid directly to the driver. Note
    that this bus does not run on weekends or public holidays. Please make sure to take Bus 39
    stating EMBL as the destination, as Bus 39 also travels to Königstuhl.
  </p>
  <h4>Taxi</h4>
  <p>
    Another option to get to and from the venue was by taxi (Tel.:&nbsp;+49&nbsp;6221&nbsp;30&nbsp;20&nbsp;30).
  </p>
  <h4>Childcare</h4>
  <p>
    Childcare was offered for children between the age of 3 months and 3 years, provided by highly
    professional Kindergarten teachers from the EMBL Kinderhaus, at a cost of €100 per child for
    the duration of the conference. Childcare could only be provided for a maximum of 10 children
    per conference, on a first-come first-served basis. For more information please visit the
    <a href="http://www.embl.de/training/events/info_participants/childcare">EMBL childcare page</a>.
  </p>
</template>

<script setup>
const hotels = [
  ["EMBL-ISG Hotel", "http://en.isg-hotel.de/"],
  ["Denner Hotel", "http://www.denner-hotel.de/"],
  ["Leonardo Hotel City Center", "https://www.leonardo-hotels.com/leonardo-hotel-heidelberg-city-center"],
  ["Hotel Anlage", "http://www.hotel-anlage.de/"],
  ["Exzellenz Hotel", "http://www.exzellenzhotel.de/en"],
  ["Boarding House", "http://www.boardinghouse-hd.de/"],
  ["Hotel Monpti", "http://www.hotel-monpti.de/"],
  ["Hotel Bayrischer Hof", "http://en.bayrischer-hof-heidelberg.com/"],
  ["Holiday Inn Express", "http://www.fmhos.de/en/hotels/holiday-inn-express-heidelberg-city-centre"],
  ["Star Inn Hotel & Suites Premium", "https://starinnhotels.com/en/star-inn-hotel-suites-premium-heidelberg-by-quality/"],
  ["B&B Hotel Heidelberg", "https://www.hotelbb.de/en/heidelberg"],
  ["Hotel Holländer Hof", "http://www.hollaender-hof.de/index.php/en/"],
  ["Steffi's Hostel Heidelberg", "http://www.hostelheidelberg.de/en/"],
  ["Crowne Plaza Hotel", "http://crowne-plaza-heidelberg.h-rez.com/"]
];
</script>

<style scoped>
div#hotels {
  columns: 3;
  margin-bottom: 1em;
}
div#hotels a {
  display: block;
  margin-bottom: 8px;
}
ul {
  list-style-type: disc;
  padding-left: 18px;
  margin-bottom: 1em;
}
img {
  width: 100%;
}
p.centered {
  text-align: center;
}
a.bus-schedule-link {
  display: block;
}
</style>
